import React, { useEffect, useState } from "react";
import { ELightPath } from "../../../../Model/CaptureProfile";
import { CartesianCoordinate } from "../../../../Model/Coordinate";
import { PolarizerOffsetsCalibration, StageOffsetCalibration } from "../../../../Model/ImagerCalibration";
import { getOneImagerCapabilities } from "../../../../redux/reducers/ImagerCapabilitiesReducer";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import LightPathUtil from "../../../../Utility/LightPathUtil";
import CommandPanel from "../../../CommandPanel/CommandPanel";
import TabPanel from "../../../PlateTypeEditor/TabPanel";
import { getModuleState } from "../../../../redux/reducers/ModuleStateReducer";
import ImagerUtil from "../../../../Utility/ImagerUtil";
import ServicingTable, { ServicingTableRow } from "../../../Common/ServicingTable";
import ImagerManualControl from "../../../Imager/ImagerManualControl";
import './PolarizeOffsets.css'
import { off } from "process";


interface PolarizerRow {
  id: string;
  name: string;
  x: number;
  y: number;
  z: number;
  selected: boolean;
}

export interface PolarizerCalibration {
  off: PolarizerRow;
  on: PolarizerRow;
}


type Props = {
  imagerIdentifier: string;
  backBtn: () => void;
  polarizerCalibration: PolarizerCalibration;
  setPolarizerCalibration: (calibration: PolarizerCalibration) => void;
  polarizerOffsetsCalibration: PolarizerOffsetsCalibration;
};


export default function PolarizeOffsets({
  imagerIdentifier,
  backBtn,
  polarizerCalibration,
  setPolarizerCalibration,
  polarizerOffsetsCalibration
}: Props) {
  const moduleState = useTypedSelector((state) =>
    getModuleState(state, imagerIdentifier)
  );



  const imagerState = moduleState.imager;
  if (imagerState == null) {
    throw new Error("Imager state is null");
  }

  const onInputPosition = (
    row: ServicingTableRow
  ) => {

    let updatedData = { ...polarizerCalibration };
    if (row.id === polarizerCalibration.off.id) {
      updatedData = {
        ...polarizerCalibration,
        off: {
          ...row
        }
      };
    }

    if (row.id === polarizerCalibration.on.id) {
      updatedData = {
        ...polarizerCalibration,
        on: {
          ...row
        }
      };
    }


    setPolarizerCalibration(updatedData);
  };

  const handleSelectRow = (id: string) => {
    let updatedData = { ...polarizerCalibration };
    const isOnSelected = id === polarizerCalibration.on.id;
    updatedData = {
      on: {
        ...polarizerCalibration.on,
        selected: isOnSelected
      },
      off: {
        ...polarizerCalibration.off,
        selected: !isOnSelected
      }
    };
    setPolarizerCalibration(updatedData);
  }

  // useEffect(() => {
  //   setPolarizerOffsets({
  //     x: Math.abs(polarizeData[polarizerName.off].x - polarizeData[polarizerName.on].x),
  //     y: Math.abs(polarizeData[polarizerName.off].y - polarizeData[polarizerName.on].y),
  //     z: Math.abs(polarizeData[polarizerName.off].z - polarizeData[polarizerName.on].z),
  //   });

  //   if (
  //     ['x', 'y', 'z'].some(
  //     (axis) =>
  //       Math.abs(
  //       polarizeData[polarizerName.off][axis as 'x' | 'y' | 'z'] -
  //       polarizeData[polarizerName.on][axis as 'x' | 'y' | 'z']
  //       ) > 0
  //     )
  //   ) {
  //     setIsCalibrationUpdated(true)
  //   } else {
  //     setIsCalibrationUpdated(false)
  //   }
  // }, [polarizeData])

  return (
    <CommandPanel
      style={{
        overflowY: "auto",
        WebkitBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        MozBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      <CommandPanel.DarkBackArrowHeader
        title="Polarize Offsets"
        onBackArrowClick={backBtn}
        style={{
          height: 60,
        }}
      />

      <ServicingTable
        imagerIdentifier={imagerIdentifier}
        imagerState={imagerState}
        dropNumber={0}
        onDropNumberChanged={() => { }}
        maxDrop={0}
        data={[polarizerCalibration.off, polarizerCalibration.on]}
        onRowSelected={(row) => handleSelectRow(row.id)}
        onRowUpdated={onInputPosition}
        style={{
          padding: "8px",
        }}
        actionLabel="Action"
        disabled={imagerState.activeLightPath !== ELightPath.Visible}
      />

      <div className="resultContainer">
        <h3>Result</h3>
        <div className="resultValue">
          <p>X:</p>
          <span>{polarizerOffsetsCalibration.offset.x.toFixed(2)}</span>
          <p>mm</p>
        </div>
        <div className="resultValue">
          <p>Y:</p>
          <span>{polarizerOffsetsCalibration.offset.y.toFixed(2)}</span>
          <p>mm</p>
        </div>
        <div className="resultValue">
          <p>Z:</p>
          <span>{polarizerOffsetsCalibration.offset.z.toFixed(2)}</span>
          <p>mm</p>
        </div>
      </div>

      <ImagerManualControl
        wellLimitEnabled={false}
        imagerIdentifier={imagerIdentifier}
        style={{
          overflow: "none",
        }}
      />
    </CommandPanel>
  );
}
